module.exports = __webpack_public_path__ + "static/media/address_proof_rear.04abd54d.svg";